<template>
  <div class="hightScore">
    <h1>高分学员分享</h1>
    <div
      class="scoreCard"
      v-for="(ele, index) in collectList.slice(
        (page - 1) * pagesize,
        page * pagesize
      )"
      :key="index"
    >
      <img
        class="cardImg"
        :src="'https://cdn.scoreupup.com' + ele.img"
        @click="lookInfo(ele.id)"
      />
      <div class="scoreCardRight" @click="lookInfo(ele.id)">
        <h2>{{ ele.title }}</h2>
        <div>
          <a>{{ ele.author }}</a>
          <a><img src="@/assets/lookWihte.png" /></a>
          <a>{{ ele.view_count }}</a>
          <a v-show="ele.is_collection == 0" @click="goCollect(ele.id)"
            ><img src="@/assets/cancleCollectIcon.png"
          /></a>
          <a v-show="ele.is_collection == 0">未收藏</a>
          <a v-show="ele.is_collection == 1" @click="goCollect(ele.id)"
            ><img src="@/assets/allSubject/choiceCollect.png"
          /></a>
          <a v-show="ele.is_collection == 1">已收藏</a>
        </div>
        <span @click="lookInfo(ele.id)">{{ ele.description }}</span>
      </div>
    </div>
    <!--   <el-pagination
      background
      layout="prev, pager, next"
      :pager-count="limit"
      :current-page="page"
      :current-change="choiceTag"
      :total="total">
    </el-pagination> -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="choiceTag"
      :total="collectList.length"
      :current-page="page"
      :page-size="pagesize"
    ></el-pagination>
  </div>
</template>

<script>
import api from "@/api/aboutGMAT.js";
export default {
  data() {
    return {
      collectList: [],
      page: 1,
      pagesize: 15,
      limit: 10,
      total: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        page: this.page,
        limit: this.limit,
      };
      let query = this.$qs.stringify(params);
      api
        .mostShare(query)
        .then((res) => {
          this.collectList = res.data.data;
          console.log(res);
        })
        .catch((err) => {
          this.$message.error("获取数据失败");
        });
    },
    choiceTag(ele) {
      this.page = ele;
      console.log(ele);
      // this.$router.push(`/introduce`)
    },
    //查看详情
    lookInfo(ids) {
      this.$router.push(`/shareInfos/${ids}`);
      console.log(ids);
    },
    goCollect(id) {
      console.log(id);
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      api
        .collect(query)
        .then((res) => {
          this.getData();
        })
        .catch((err) => {
          this.$message.error("操作失败");
        });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/hightScore.css";
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/hightScore.vue